jQuery(function ($) {

////////////////////////////////////
///object-fit用
////////////////////////////////////

	objectFitImages();

});